<template>
    <div class="add_config_mask"  v-if="addOk">
    <el-card class="add_config">
        <div slot="header" class="clearfix" style="text-align:center;">
            <span style="line-height: 36px;">新增账号</span>
        </div>
        <div>
            <el-tabs v-model="activeName" type="card">
                <el-tab-pane label="一键配置" name="first">
                    <div class="weixin-setting-con">
                        <div class="alert alert-info">
                            点击登录授权后使用该个人号的管理员微信号扫描后进行授权绑定即可完成配置。个人号授权功能已通过
                            <a href="https://open.weixin.qq.com/cgi-bin/frame?t=home/wx_plugin_tmpl&amp;lang=zh_CN&amp;token=f2bf8fee3ba7ba1180f81bdc5d981cf475b773ea" target="_blank">
                                微信官方第三方平台认证
                            </a>
                            安全可靠,只需要授权消息权限并且本平台只会回复666消息,不会影响您个人号的其他业务。使用一键配置的个人号可以查看掉粉情况分析。
                        </div>
                        <div class="alert alert-warning">
                            请注意:如果您之前使用了手动配置,请在一键授权成功后取消手动配置的666回复,否则发送666会收到两条回复。如果您在个人号后台取消授权,您的任务将会自动下架。
                        </div>
                        <div class="form-group">
                            <label class="col-lg-1">点击授权</label>
                            <div class="col-lg-2">
                                <div>
                                    <a id="testEnter" :href="url" target="_blank">
                                        <img style="width: 220px;height: 48px;" src="https://open.weixin.qq.com/zh_CN/htmledition/res/assets/res-design-download/icon_button3_2.png">
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="手动配置" name="second">
                    <div class="tab-content weixin-setting-con ">
                        <div class="" id="weixin-dialog-tab-default-content" style="display: block;">
                            <div class="">
                                <label class="col-lg-1">文本链接</label>
                                <div class="col-lg-2" style="padding-left: 0;">
                                    <div>
                                        <p id="myCopy1" class="text-link ng-binding" style="margin-bottom: 0;margin-top:0;font-size:13px">☞ &lt;a href="<el-input readonly id="myCopy" v-model="href1"></el-input>"&gt;点我免费领取&lt;/a&gt; ☜</p>
                                        <a style="border-bottom: dashed 1px #0088cc;font-size: 11px; color:red;cursor:pointer;" class="copy-to-board" @click="copyText()">点击复制文本链接</a>
                                    </div>
                                </div>
                            </div>
                            <div class="">
                                <label class="col-lg-1">配置说明</label>
                                <div class="col-lg-2" style="padding-left: 0;">
                            <textarea class="form-control" id="exampleTextarea" readonly="" style="background-color: #eee;opacity: 1;height: 180px; width:560px; font-size:12px;padding:15px;border:1px solid lightgray;">推荐使用第三方平台。
                                
                                
注：
1、如果使用第三方平台，请在第三方平台设置。
2、操作完成后必须在本界面点击完成按钮，才完成个人号配置。
                            </textarea>
                                    <span class="help-block" style="color:red">按以上要求配置后，推广任务才能通过审核！</span>
                                </div>
                            </div>

                            <div class="" style="text-align:center;">
                                <el-button type="success" @click="commit" style="width: 240px;margin-top:20px;">完成</el-button>
                            </div>

                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
        <span @click="boxColose" style="position: absolute; top: 0;right:0;padding:10px;color:#FF4949"><i class="el-icon-close Danger"></i></span>
    </el-card>
    </div>
</template>
<script>
    import $ajax from '../../https/config'
    export default {
      props: ['addShow', 'myAppid', 'url'],
      data () {
        return {
          labelPosition: 'right',
          loading: false,
          activeName: 'first',
          fromAddAccount: {
            user_name: '',
            user_type: '3',
            password: '',
            pwdAgain: '',
            nickName: ''
          }
        }
      },
      computed: {
        addOk: function () {
          return this.addShow
        },
        href1: function () {
          return 'http://zhi.songzb.com/point/zhi-out.html?appid=' + this.myAppid
        },
        href2: function () {
            return 'http://knowme.songzb.com/wechat/2.html?appid=' + this.myAppid
        }
      },
      methods: {
        boxColose () {
          this.$emit('closeAddAccount', false)
        },
        copyText () {
        //   var d = document.getElementById('myCopy1')
        //   console.log(document.getElementById('myCopy1'))
        //   console.log(document.getElementById('myCopy').childNodes[1])
        //   console.log(document.getElementById('myCopy').childNodes[2])
             var s = '☞'+ '<a href="http://zhi.songzb.com/point/zhi-out.html?appid='+this.myAppid+'">点我免费领取</a>'+' ☜'
        //   d.nodeValue = s
        //   d.select()

            const input = document.createElement('input')
            document.body.appendChild(input)
            input.setAttribute('value', s)
            input.select()

          document.execCommand('Copy')
          this.$message({
            message: '已成功复制',
            type: 'success'
          })
        },
        commit () {
            var that = this
            var params = {
                appId: this.myAppid,
                status: 0
            }
            $ajax.get('/wxqyv2/sbz/updateWxStatus', params, 'headers', function (res) {
          if (res && res.resultStatus === true) {
            that.$message({
              type: 'success',
              message: "公众号授权成功！"
            })
          } else {
            that.$message({
              type: 'error',
              message: res.errorMessage
            })
          }
            }, function () {
          that.$message({
            type: 'error',
            message: msg2
          })
            })
        }
      }
    }
</script>
<style lang="scss">
  .add_config_mask {
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      position: fixed;
      background: rgba(#000, 0.3);
      z-index: 100;
      text-align: left;
  #myCopy {
      display: inline;
  }
  #myCopy input{
      border: 0;
      width: 74%;
      padding: 0;
  }
  .add_config{
    min-height: 530px;
    width: 800px;
    top: 20%;
    left: 40%;
    z-index: 101;
    margin-left: -200px;
    position: fixed;

    .el-card__header {
        padding: 10px
    }
    .el-tabs__header {
        margin-bottom: 0;
    }
    .weixin-setting-con {
        border: 1px solid #c5d0dc;
        padding: 16px 12px;
        position: relative;
        border-top: none;
        margin-top: -1px;
        height: 380px;
    }
    .alert {
        padding: 15px;
        margin-bottom: 20px;
        border: 1px solid transparent;
        border-radius: 4px;
    }
    .form-control {
        border-radius: 1px;
        color: inherit;
        display: block;
        line-height: 1.42857143;
    }
    #exampleTextarea {
        background-color: #eee;
        opacity: 1;
        height: 240px; 
        width:560px; 
        font-size:12px;
        padding:15px;
        border:1px solid lightgray;
        font-family: Microsoft YaHei;
    }
    .col-lg-1 {
        width: 12.66666667%;
        float: left;
        font-weight: 700;
        color: #777;
    }
    .col-lg-2 {
        width: 85%;
        float: left;
    }
    .alert-info {
        color: #31708f;
        background-color: #d9edf7;
        border-color: #bce8f1;
        a {
            color: #0781ea;
        }
    }
    .alert-warning {
        color: #8a6d3b;
        background-color: #fcf8e3;
        border-color: #faebcc;
    }
    .el-card__body {
        padding: 20px 40px;
        .el-form-item {
            width: 90%
        }
    }
  }
  }
</style> 


// WEBPACK FOOTER //
// src/page/adMgr/personAuth.vue